"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationMigrations = void 0;
const migration_16_0_0_1 = require("./migration_16_0_0");
const migration_17_0_0_1 = require("./migration_17_0_0");
const migration_20_0_0_1 = require("./migration_20_0_0");
const migration_32_1_2_1 = require("./migration_32_1_2");
const migration_34_0_0_1 = require("./migration_34_0_0");
const migration_38_0_0_1 = require("./migration_38_0_0");
const migration_4_0_0_1 = require("./migration_4_0_0");
const migration_4_2_1_1 = require("./migration_4_2_1");
const migration_54_2_0_1 = require("./migration_54_2_0");
const migration_58_0_0_1 = require("./migration_58_0_0");
const migration_58_1_0_1 = require("./migration_58_1_0");
const migration_60_0_0_1 = require("./migration_60_0_0");
// import {migration_63_0_0} from './migration_63_0_0';
const migration_64_2_0_1 = require("./migration_64_2_0");
const migration_66_4_0_1 = require("./migration_66_4_0");
const migration_67_0_0_1 = require("./migration_67_0_0");
const migration_68_0_0_1 = require("./migration_68_0_0");
const migration_69_0_0_1 = require("./migration_69_0_0");
const migration_69_10_3_1 = require("./migration_69_10_3");
const migration_69_13_0_1 = require("./migration_69_13_0");
const migration_70_3_0_1 = require("./migration_70_3_0");
const migration_72_0_0_1 = require("./migration_72_0_0");
const migration_73_9_1_1 = require("./migration_73_9_1");
const migration_73_33_0_1 = require("./migration_73_33_0");
const migration_73_39_0_1 = require("./migration_73_39_0");
const migration_75_0_0_1 = require("./migration_75_0_0");
const migration_75_13_0_1 = require("./migration_75_13_0");
const migration_75_15_0_1 = require("./migration_75_15_0");
const migration_75_16_0_1 = require("./migration_75_16_0");
const migration_75_20_0_1 = require("./migration_75_20_0");
const migration_75_36_0_1 = require("./migration_75_36_0");
const migration_77_0_0_1 = require("./migration_77_0_0");
const migration_78_4_0_1 = require("./migration_78_4_0");
const migration_81_12_1_1 = require("./migration_81_12_1");
const migration_81_29_0_1 = require("./migration_81_29_0");
const migration_81_29_1_1 = require("./migration_81_29_1");
const migration_81_51_1_1 = require("./migration_81_51_1");
const migration_81_52_1_1 = require("./migration_81_52_1");
const migration_83_0_0_1 = require("./migration_83_0_0");
const migration_83_19_3_1 = require("./migration_83_19_3");
const migration_83_20_0_1 = require("./migration_83_20_0");
const migration_84_0_0_1 = require("./migration_84_0_0");
const migration_85_1_0_1 = require("./migration_85_1_0");
const migration_85_2_0_1 = require("./migration_85_2_0");
const migration_85_2_1_1 = require("./migration_85_2_1");
const migration_85_3_0_1 = require("./migration_85_3_0");
const migration_96_21_0_1 = require("./migration_96_21_0");
const migration_96_55_0_1 = require("./migration_96_55_0");
const migration_96_101_0_1 = require("./migration_96_101_0");
const migration_96_102_0_1 = require("./migration_96_102_0");
const migration_96_103_0_1 = require("./migration_96_103_0");
// prettier-ignore
exports.configurationMigrations = [
    { version: '4.0.0', migrate: migration_4_0_0_1.migration_4_0_0 },
    { version: '4.2.1', migrate: migration_4_2_1_1.migration_4_2_1 },
    { version: '16.0.0', migrate: migration_16_0_0_1.migration_16_0_0 },
    { version: '17.0.0', migrate: migration_17_0_0_1.migration_17_0_0 },
    { version: '20.0.0', migrate: migration_20_0_0_1.migration_20_0_0 },
    { version: '32.1.2', migrate: migration_32_1_2_1.migration_32_1_2 },
    { version: '34.0.0', migrate: migration_34_0_0_1.migration_34_0_0 },
    { version: '37.3.3', migrate: migration_38_0_0_1.migration_38_0_0 },
    { version: '54.2.0', migrate: migration_54_2_0_1.migration_54_2_0 },
    { version: '58.0.0', migrate: migration_58_0_0_1.migration_58_0_0 },
    { version: '58.1.0', migrate: migration_58_1_0_1.migration_58_1_0 },
    { version: '60.0.0', migrate: migration_60_0_0_1.migration_60_0_0 },
    // TODO: EKE-7386: something fishy is going on here.
    // {version: '63.0.0', migrate: migration_63_0_0},
    { version: '64.2.0', migrate: migration_64_2_0_1.migration_64_2_0 },
    { version: '66.4.0', migrate: migration_66_4_0_1.migration_66_4_0 },
    { version: '67.0.0', migrate: migration_67_0_0_1.migration_67_0_0 },
    { version: '68.0.0', migrate: migration_68_0_0_1.migration_68_0_0 },
    { version: '69.0.0', migrate: migration_69_0_0_1.migration_69_0_0 },
    { version: '69.10.3', migrate: migration_69_10_3_1.migration_69_10_3 },
    { version: '69.0.0', migrate: migration_69_13_0_1.migration_69_13_0 },
    { version: '70.3.0', migrate: migration_70_3_0_1.migration_70_3_0 },
    { version: '72.0.0', migrate: migration_72_0_0_1.migration_72_0_0 },
    { version: '73.9.1', migrate: migration_73_9_1_1.migration_73_9_1 },
    { version: '73.33.0', migrate: migration_73_33_0_1.migration_73_33_0 },
    { version: '73.39.0', migrate: migration_73_39_0_1.migration_73_39_0 },
    { version: '75.0.0', migrate: migration_75_0_0_1.migration_75_0_0 },
    { version: '75.13.0', migrate: migration_75_13_0_1.migration_75_13_0 },
    { version: '75.15.0', migrate: migration_75_15_0_1.migration_75_15_0 },
    { version: '75.16.0', migrate: migration_75_16_0_1.migration_75_16_0 },
    { version: '75.20.0', migrate: migration_75_20_0_1.migration_75_20_0 },
    { version: '75.36.0', migrate: migration_75_36_0_1.migration_75_36_0 },
    { version: '77.0.0', migrate: migration_77_0_0_1.migration_77_0_0 },
    { version: '78.4.0', migrate: migration_78_4_0_1.migration_78_4_0 },
    { version: '81.13.0', migrate: migration_81_12_1_1.migration_81_12_1 },
    { version: '81.29.0', migrate: migration_81_29_0_1.migration_81_29_0 },
    { version: '81.29.1', migrate: migration_81_29_1_1.migration_81_29_1 },
    { version: '81.51.1', migrate: migration_81_51_1_1.migration_81_51_1 },
    { version: '81.52.1', migrate: migration_81_52_1_1.migration_81_52_1 },
    { version: '83.0.0', migrate: migration_83_0_0_1.migration_83_0_0 },
    { version: '83.19.3', migrate: migration_83_19_3_1.migration_83_19_3 },
    { version: '83.20.0', migrate: migration_83_20_0_1.migration_83_20_0 },
    { version: '84.0.0', migrate: migration_84_0_0_1.migration_84_0_0 },
    { version: '85.1.0', migrate: migration_85_1_0_1.migration_85_1_0 },
    { version: '85.2.0', migrate: migration_85_2_0_1.migration_85_2_0 },
    { version: '85.2.1', migrate: migration_85_2_1_1.migration_85_2_1 },
    { version: '85.3.0', migrate: migration_85_3_0_1.migration_85_3_0 },
    { version: '96.21.0', migrate: migration_96_21_0_1.migration_96_21_0 },
    { version: '96.55.0', migrate: migration_96_55_0_1.migration_96_55_0 },
    { version: '96.101.0', migrate: migration_96_101_0_1.migration_96_101_0 },
    { version: '96.102.0', migrate: migration_96_102_0_1.migration_96_102_0 },
    { version: '96.103.0', migrate: migration_96_103_0_1.migration_96_103_0 }
];
//# sourceMappingURL=configurationMigrations.js.map